export default "__VITE_ASSET__DTlMdSpL__"